import React from "react";
import { Helmet } from "react-helmet";

import Layout from "../../components/Layout";
import InfoFooter from "../../components/InfoFooter";

const unsplashPhotos = [
  {
    author: "Harpreet Singh",
    authorUrl:
      "https://unsplash.com/@harpreetkaka?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    sourceUrl:
      "https://unsplash.com/?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    author: "NeONBRAND",
    authorUrl:
      "https://unsplash.com/@neonbrand?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    sourceUrl:
      "https://unsplash.com/s/photos/glasses-case?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    author: "Marina Vitale",
    authorUrl:
      "https://unsplash.com/@marina_mv08?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    sourceUrl:
      "https://unsplash.com/s/photos/eye-examination?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    author: "nrd",
    authorUrl:
      "https://unsplash.com/@nicotitto?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    sourceUrl:
      "https://unsplash.com/s/photos/optics?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    author: "CHUTTERSNAP",
    authorUrl:
      "https://unsplash.com/@chuttersnap?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    sourceUrl:
      "https://unsplash.com/s/photos/glasses-store?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
];

const flaticonAuthors = [
  { name: "Freepik", url: "https://www.freepik.com" },
  { name: "Smashicons", url: "https://www.flaticon.com/authors/smashicons" },
  { name: "Good Ware", url: "https://www.flaticon.com/authors/good-ware" },
  { name: "fjstudio", url: "https://www.flaticon.com/authors/fjstudio" },
  { name: "phatplus", url: "https://www.flaticon.com/authors/phatplus" },
];

const AutorskaPrava = () => (
  <Layout>
    <Helmet
      title="Autorská práva | Optika Volyně"
      meta={[
        {
          name: "description",
          content: "Autorská práva vztahující se k obsahu na webu Optiky Volyně",
        },
        {
          name: "keywords",
          content: "Optika, Optometrie, Volyně, Autorská práva",
        },
      ]}
    />
    <div className="additional-pages-nav" />
    <main className="additional-pages-main">
      <h1>Autorská práva</h1>

      <h2>Autoři ilustračních fotografií ze serveru Unsplash</h2>
      {unsplashPhotos.map((photo) => (
        <div key={photo.author}>
          Photo by{" "}
          <a href={photo.authorUrl} target="_blank" rel="noreferrer">
            {photo.author}
          </a>{" "}
          on{" "}
          <a href={photo.sourceUrl} target="_blank" rel="noreferrer">
            Unsplash
          </a>
        </div>
      ))}

      <h2>Autoři ikon ze serveru Flaticon</h2>
      {flaticonAuthors.map((author) => (
        <div key={author.name}>
          Icons made by{" "}
          <a
            href={author.url}
            title={author.name}
            target="_blank"
            rel="noreferrer"
          >
            {author.name}
          </a>{" "}
          from{" "}
          <a
            href="https://www.flaticon.com/"
            title="Flaticon"
            target="_blank"
            rel="noreferrer"
          >
            www.flaticon.com
          </a>
        </div>
      ))}

      <h2>Autor ikony ze serveru TheNounProject</h2>
      <p>
        Noun Project “glasses box” icon by Chananan, from thenounproject.com.
      </p>
    </main>
    <InfoFooter className="additional-pages-footer" />
  </Layout>
);

export default AutorskaPrava;
